import React from 'react';

interface WindowBackgroundProps extends React.SVGProps<SVGSVGElement> {
  url: string;
}

export const WindowBackground = ({ url, ...props }: WindowBackgroundProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="-15 -15 585 440"
      {...props}
    >
      <g>
        <defs>
          <path id="builderWindow__c" d="M-15-14.9h584.2v439H-15z" />
        </defs>
        <clipPath id="builderWindow__d">
          <use xlinkHref="#builderWindow__c" overflow="visible" />
        </clipPath>
        <g clipPath="url(#builderWindow__d)">
          <image
            width={999}
            height={644}
            href={url}
            transform="translate(-240.843 -89.871) scale(1.0265)"
            overflow="visible"
          />
        </g>
      </g>
    </svg>
  );
};
